var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrimaryModeratorCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1490",
    "data-name": "Group 1490",
    transform: "translate(-247 -60)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1051",
    "data-name": "Rectangle 1051",
    width: 31,
    height: 31,
    rx: 15.5,
    transform: "translate(247 60)",
    opacity: 0.499
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1477",
    "data-name": "Group 1477",
    transform: "translate(23960 4698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-23708 -4630)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M128.326,14.333a2.26,2.26,0,0,1-.5-.968,1.995,1.995,0,0,1,3.855-1.025,1.522,1.522,0,0,0,.093.326v.565a4.837,4.837,0,0,1-.2.6,2.018,2.018,0,0,1-1.211,1.037l-.157.051a.572.572,0,0,0-.126.009,1.972,1.972,0,0,1-.8-.035A2.127,2.127,0,0,1,128.326,14.333Z",
    transform: "translate(-110.779 -9.417)",
    fill: "#fec031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M85.985,27.124a2.127,2.127,0,0,0,.968.561,1.972,1.972,0,0,0,.8.035.584.584,0,0,0,.126-.009c-.092.7-.2,1.4-.354,2.089a10.961,10.961,0,0,1-1.239,3.341.223.223,0,0,1-.033.039H78.93V26.207a1.986,1.986,0,0,0,1.424-.6,2.678,2.678,0,0,0,.5,1.2,3.094,3.094,0,0,0,1.7,1.248,3.208,3.208,0,0,0,2.978-.511,3,3,0,0,0,.461-.42Z",
    transform: "translate(-68.438 -22.208)",
    fill: "#fcf286"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M20.76,26.545V33.51H13.448a9.367,9.367,0,0,1-1.008-2.362,16.334,16.334,0,0,1-.4-1.7c-.086-.464-.142-.931-.211-1.4a1.014,1.014,0,0,1,.133,0,2.031,2.031,0,0,0,1.151-.166,2.927,2.927,0,0,0,.6-.417,3.139,3.139,0,0,0,1.462.931,3.21,3.21,0,0,0,3.208-.734A3.257,3.257,0,0,0,19.352,26a.167.167,0,0,1,.108.058,1.994,1.994,0,0,0,1.288.481Z",
    transform: "translate(-10.259 -22.547)",
    fill: "#febf2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M23.895,83H31.2v3.191a.215.215,0,0,0,.039.157c-.036.062-.086.044-.133.044H24.585c-.421,0-.693-.364-.694-.931C23.887,84.631,23.892,83.814,23.895,83Z",
    transform: "translate(-20.715 -71.969)",
    fill: "#faa741"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M78.917,86.437c-.044-.039-.039-.1-.039-.157V83.09h7.316v2.541c0,.465-.25.8-.593.808-.473.008-.948,0-1.421,0H79.07A.838.838,0,0,1,78.917,86.437Z",
    transform: "translate(-68.394 -72.047)",
    fill: "#fec030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M3.466,14.992a3.645,3.645,0,0,1-.614.427,2.031,2.031,0,0,1-1.151.166,1.013,1.013,0,0,0-.133,0,2.769,2.769,0,0,1-.779-.374,2,2,0,0,1-.713-2.09,1.925,1.925,0,0,1,1.611-1.474,1.972,1.972,0,0,1,2.26,1.5,1.949,1.949,0,0,1-.4,1.742C3.519,14.925,3.5,14.961,3.466,14.992Z",
    transform: "translate(-0.011 -10.077)",
    fill: "#faa741"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M80.417,3.446a1.986,1.986,0,0,1-1.417.6V.047a1.926,1.926,0,0,1,1.67.9,1.976,1.976,0,0,1-.086,2.308C80.533,3.325,80.45,3.364,80.417,3.446Z",
    transform: "translate(-68.499 -0.044)",
    fill: "#fec031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M65.9.027V4.015a1.994,1.994,0,0,1-1.288-.481c-.032-.027-.06-.061-.108-.058a1.538,1.538,0,0,0-.209-.274,1.945,1.945,0,0,1-.386-1.329A1.994,1.994,0,0,1,65.215.144,1.462,1.462,0,0,1,65.9.027Z",
    transform: "translate(-55.408 -0.023)",
    fill: "#faa741"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimaryModeratorCrown);
export default __webpack_public_path__ + "static/media/PrimaryModeratorCrown.9564f232e1cfb60319f31ca6124bc279.svg";
export { ForwardRef as ReactComponent };